export const MAZE_SCRIPT = `
  (function (m, a, z, e) {
    var s, t;
    try {
      t = m.sessionStorage.getItem('maze-us');
    } catch (err) {}  if (!t) {
      t = new Date().getTime();
      try {
        m.sessionStorage.setItem('maze-us', t);
      } catch (err) {}
    }  s = a.createElement('script');
    s.src = z + '?t=' + t + '&apiKey=' + e;
    s.defer = true;
    a.getElementsByTagName('head')[0].appendChild(s);
    m.mazeUniversalSnippetApiKey = e;
  })(window, document, 'https://snippet.maze.co/maze-universal-loader.js', 'c9eed8b6-2eee-4545-8687-9df4ed39b2f3');
`;